module.exports = __webpack_public_path__ + "img/arrowRight.8eac1c16.svg";